import api from '../../services/api';

const baseUrl = 'crm/voice-call'

const generateToken = async (sellerId) =>
    api.get({ service: `${baseUrl}/token` });

const update = async (voiceCallId, data) =>
    api.put({ service: `${baseUrl}/${voiceCallId}`, data });

const findByCustomerId = async (customerId, pagination) =>
    api.post({ service: `${baseUrl}/customer/${customerId}/filter`, data: { pagination } });

const findByProviderCallId = async (providerCallId) =>
    api.get({ service: `${baseUrl}/provider-call-id/${providerCallId}` });

const findDiagnosticsByProviderCallId = async (providerCallId) =>
    api.get({ service: `${baseUrl}/provider-call-id/${providerCallId}/diagnostics` });

const saveQualityTelemetryByProviderCallId = async (providerCallId, data) =>
    api.post({ service: `${baseUrl}/provider-call-id/${providerCallId}/telemetry`, data });

export default {
    generateToken,
    update,
    findByCustomerId,
    findByProviderCallId,
    findDiagnosticsByProviderCallId,
    saveQualityTelemetryByProviderCallId
}
